import axios from 'axios';
import router from '@/router';
import { Message } from 'element-ui';

// 创建axios实例
const request = axios.create({
  // baseURL: process.env.PRIVATE_CLOUD_WM_API, // api的base_url
  baseURL: '',
  timeout: 8 * 60 * 60 * 1000   // 请求超时时间
});

// request拦截器
request.interceptors.request.use(config => {
  //
  return config;
}, error => {
  // Do something with request error
  console.log(error); // for debug
  Promise.reject(error);
})

request.interceptors.response.use(
  response => response,
  error => {
    console.log('err' + error);// for debug
    const routerData = {path: '/error', query:{}};
    router.app.$router.push(routerData);
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // });
    return Promise.reject(error);
  }
)

export default request;



// WEBPACK FOOTER //
// ./src/utils/request.js